exports.CentsToDollars = function(cents) {
  let dollars = (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
  return dollars;
};
